import { createAsyncThunk, createEntityAdapter, createSelector, createSlice } from '@reduxjs/toolkit'
import { ObjectiveRecord, ObjectiveRecordApi } from '@/api/models/objectiveRecord'
import { RootState } from '@/store'

export const objectiveRecordAdapter = createEntityAdapter({
  selectId: (objectiveRecord: ObjectiveRecord) => objectiveRecord.id,
})

const initialState = {
  loaded: false,
  objectiveRecords: objectiveRecordAdapter.getInitialState(),
}

export const fetchMyObjectiveRecordsAsync = createAsyncThunk<ObjectiveRecord[], Record<string, any>>(
  'fetchMyObjectiveRecordsAsync/fetch',
  (queries) => {
    return ObjectiveRecordApi.query(queries)
  },
)

export const objectiveRecordsSlice = createSlice({
  name: 'objectiveRecords',
  initialState,
  reducers: {
    reset(state) {
      state.loaded = false
      state.objectiveRecords = objectiveRecordAdapter.getInitialState()
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchMyObjectiveRecordsAsync.fulfilled, (state, action) => {
      state.loaded = true
      state.objectiveRecords = objectiveRecordAdapter.setMany(state.objectiveRecords, action.payload)
    })
  },
})

const rootSelector = (state: RootState) => state.objectiveRecords.objectiveRecords
export const objectiveRecordsIdsSelector = createSelector(rootSelector, (objectiveRecords) =>
  objectiveRecordAdapter.getSelectors().selectIds(objectiveRecords),
)
export const createObjectiveRecordSelector = () =>
  createSelector(
    rootSelector,
    (state: RootState, id: string) => id,
    (state, id) => {
      return objectiveRecordAdapter.getSelectors().selectById(state, id)
    },
  )

export const { reset } = objectiveRecordsSlice.actions

export default objectiveRecordsSlice.reducer
